/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const DELETEAWARD= createAsyncThunk(
  "deleteAward/deleteAward",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deleteAwardSlice = createSlice({
  name: "deleteAwardSlice",
  initialState: {
    deleteAward: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeleteAward: (state) => {
        state.deleteAward.loading = false
        state.deleteAward.error = false
        state.deleteAward.data = []
        state.deleteAward.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETEAWARD.fulfilled, (state, action) => {
      state.deleteAward = {
        ...state.deleteAward,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEAWARD.pending, (state, action) => {
      state.deleteAward = {
        ...state.deleteAward,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEAWARD.rejected, (state, action) => {
      state.deleteAward = {
        ...state.deleteAward,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deleteAwardAction = {
    DELETEAWARD,
};

export { deleteAwardAction };
export default deleteAwardSlice.reducer;
export const {setInitialStateOfdeleteAward} = deleteAwardSlice.actions